import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from "../../../../../environments/environment";
import {UtilityService} from "../../utility.service";
import {CommonResponse} from "../../../response/common.response";


@Injectable({
    providedIn: 'root'
})
export class ApiBookingRepository {
    /**
     * Contiene la ruta de conexión a servicios publicos
     */
    API_URI = environment.API_URI;

    // tslint:disable-next-line:max-line-length
    constructor(private http: HttpClient, private utilityService: UtilityService) {
    }


    // @ts-ignore
    public async getLocales(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/listarSedes').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getOperadores(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visorexportador/listarOperadores').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getNavesAll(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/listarNaves').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getLineasAll(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/listarLineas').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getViajeAllByNave(nave_id: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/listarViajesByNave/'+nave_id).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getListTipoContenedor(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/getTiposContenedor').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getListTipoContenedorUser(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/getTipoContenedorUserList').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async obtenerOperacionesOperadorFiltros(objEnvio: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/getOperacionesOperadorFiltros', objEnvio).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async updateReferencia(objEnvio: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/updateReferencia', objEnvio).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async obtenerPlazos(objEnvio: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/getPlazos', objEnvio).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async obtenerCanales(objEnvio: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/getCanalesBooking', objEnvio).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getTrackingDamByID(bookingdamId: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/getTrackingDamByID/' + bookingdamId).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async obtenerDatosParaVisorCliente(bookingId: number): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'booking/obtenerDatosParaVisorCliente/' + bookingId).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getFilesBookingList(bookingId: number): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'booking/getFilesBookingList/' + bookingId).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async deleteFileByID(id: number): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.delete(this.API_URI + 'booking/deleteFileByID/'+ id).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async obtenerListaDocumentacionOperador(params: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/getOperacionesDocumentacion', params).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async obtenerPageReportsDatosFinales(bookingId: number): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'booking/getPageReportDatosFinales/' + bookingId).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async obtenerReporteStatusDocumentario(params: any): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/reporteStatusDocumentario', params).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async obtenerReporteOperacionesFinales(params: any): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/reporteOperacionesFinales', params).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async obtenerReporteMatricesOperador(params: any): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/getMatricesListOperador', params).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getVGM(bookingId: number): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/getVGMByID/' + bookingId).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getMatriz(bookingId: number): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/getMatrizByID/' + bookingId).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getDatosFinales(bookingId: number): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/getDatosFinalesByID/' + bookingId).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getBL(bookingId: number): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/getBLByID/' + bookingId).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async statusOKBL(bookingId: number): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/statusOKBL/' + bookingId).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async statusCorrecionBL(bookingId: number, obj: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/statusCorrecionBL/' + bookingId, obj).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getStatusBLList(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/getStatusListBL').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async enviarCorreoCorrecionBL(bookingdataId: number): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/enviarNotificacionCorrecionByData/' + bookingdataId).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }
    // @ts-ignore
    public async enviarCorreoDocumentoDAM(documentodam_id: number): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/enviarNotificacionByDocumento/' + documentodam_id).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }
    // @ts-ignore
    public async adjuntarArchivo(file: FormData): Promise<CommonResponse> {
        try {
            // tslint:disable-next-line:max-line-length
            const responseSuccess = await this.http.post(this.API_URI + 'operario/adjuntarArchivo', file).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async adjuntarDocumentoDAM(obj: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/adjuntarDocumentoDAM', obj).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async adjuntarDocumentoBK(obj: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/adjuntarDocumentoBK', obj).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getCitasByFiltros(params: any): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/getCitasListByOperador', params).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async searchBookingCitaList(params: any): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/searchBookingCitaList', params).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }
    // @ts-ignore
    public async listarTransporteBySede(localid: any): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/listarTransporteBySede/'+ localid).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }
    // @ts-ignore
    public async listarTransporteSedeByQuery(localid: any, objEnvio: any): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/listarTransporteSedeByQuery/'+ localid, objEnvio).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }
    // @ts-ignore
    public async listarConductorSedeByQuery(localid: any, objEnvio: any): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/listarConductorSedeByQuery/'+ localid, objEnvio).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async listarPrecintoByQuery(localid: any, objEnvio: any): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/listarPrecintosOperador', objEnvio).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }
    // @ts-ignore
    public async listarVehiculoTransporteByQuery(proveedorid: any, objEnvio: any): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/listarVehiculoTransporteByQuery/'+ proveedorid, objEnvio).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }
    // @ts-ignore
    public async listarConductorBySede(localid: any): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/listarConductorBySede/'+ localid).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }
    // @ts-ignore
    public async guardarCita(params: any): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/guardarCita', params).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getTrackingCita(citaid: number): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/getTrackingCita/' + citaid).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async anularCita(id: any,params: any): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/anularCita/'+id, params).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async reprogramarCita(id: any,params: any): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/reprogramarCita/'+id, params).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async nuevaCita(id: any,params: any): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/nuevaCita/'+id, params).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async importarExcelCita(id: any,params: any): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/getDatosCitaExcel/'+id, params).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getEstadosCita(): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/getEstadosCita').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getCorreosOperador(params: any): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/getCorreosOperador', params).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async guardarCorreoOperador(params: any): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/guardarCorreoOperador', params).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }
    // @ts-ignore
    public async getCorreoByID(id: any): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/getCorreoByID/' + id).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }
    // @ts-ignore
    public async eliminarCorreoByID(id: any): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.delete(this.API_URI + 'visoroperador/eliminarCorreoByID/' + id).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getTipoContenedores(): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/getTipoContenedores').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getTipoEnvioCorreo(): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/getTiposCorreoEnvio').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async importarExcelCorreos(params: any): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/importarDatosExcelCorreos', params).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }


    // @ts-ignore
    public async getDocumentoListByTipo(booking: any, documentotipo: any): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/getDocumentoListByTipoBooking/'+ booking + '/' + documentotipo).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async eliminarDocumentoByParamsBooking(booking: any, documento: any): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/eliminarDocumentoByParamsBooking/'+ booking, documento).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }
    // @ts-ignore
    public async enviarCorreoEliminarDocumentoDAM(documento: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/enviarNotificacionEliminacionByDocumento' , documento).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async guardarDatosGuiaCita(id: any,params: any): Promise<CommonResponse> {

        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/guardarDatosGuiaRemision/'+id, params).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async enviarCorreoNotificacionCita(objEnvio: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/enviarCorreoGeneracionCitas' , objEnvio).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getContenedoresByBooking(booking: any, dam: any, tipodocumento: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/obtenerContenedoresByBookingAndDAMDocumento/'+booking+'/'+dam+'/'+tipodocumento).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getOperacionesBookingRegistroList(objEnvio: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/getOperacionesBookingRegistroList' , objEnvio).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async addBooking(objEnvio: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/addBooking' , objEnvio).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async updateBooking(objEnvio: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.put(this.API_URI + 'visoroperador/updateBooking' , objEnvio).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getSemanasDisponibles(antes: any, despues: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/getSemanasDisponibles/' + antes + '/' + despues).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getByID(bookingid: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/booking/getByID/' + bookingid).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getTiposContenedorList(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/getTiposContenedorList').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }
    // @ts-ignore
    public async enviarCorreoBooking(bookingId: number): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/enviarNotificacionBookingByID/' + bookingId).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async registrarNcNd(obj: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/registrarNcNd', obj).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getNCNDByID(id: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/getNCNDByID/' + id).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async actualizarNcNd(obj: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.put(this.API_URI + 'visoroperador/actualizarNcNd', obj).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getEstadolog(id: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/getEstadolog/' + id).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async enviarNotificacionNDNC(arrayIDs: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/enviarNotificacionNCND', arrayIDs).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getNotasCreditoDebitoList(params: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/getNotasCreditoDebitoList', params).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async pagoLcMulta(obj: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.put(this.API_URI + 'visoroperador/pagoLcMulta', obj).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

}
